import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { Supplier } from '../Supplier.interface';
import { useCreateSupplier } from '../Supplier.hooks';

export interface SupplierCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (supplier: Supplier) => void;
}

const SupplierCreateDialog: React.FC<SupplierCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const {
    createdSupplier,
    isCreating,
    createError,
    createSupplier
  } = useCreateSupplier();

  useEffect(() => {
    if (!isCreating) {
      if (onCreated && createdSupplier) {
        onCreated(createdSupplier);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [createdSupplier, isCreating, onCreated]);

  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{
          companyName: ''
        }}
        validationSchema={Yup.object({
          companyName: Yup.string().required('Required')
        })}
        onSubmit={(form: any) => createSupplier(form)}
      >
        <Form autoComplete='off'>
          <DialogTitle>Create Supplier</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='companyName'
                label='Supplier Name'
              />
            </FormikGrid>
            {createError && (
              <Alert severity='error'>{`Error occurred. ${createError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default SupplierCreateDialog;
